import { FieldType } from './types'

import { InquiryFormType } from '../../utils/constants'

export const scaleByType: {
  [key in InquiryFormType['name']]: FieldType[]
} = {
  'KAPP_SNIZ_M(N)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: [
        'teacher',
        'pedagogue',
        'psychologist',
        'therapist',
        'speechTherapist',
        'other',
      ],
    },
    { name: '-2', type: 'number', title: 'workTime' },
    {
      name: 'instruction',
      type: 'instruction1T',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    { type: 'makaton' },

    {
      type: 'matrix',
      title: 'coord',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: [
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'memory',
      questions: ['22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'attention',
      questions: ['32', '33', '34', '35', '36', '37'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['38', '39', '40', '41', '42', '43', '44', '45', '46', '47'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: [
        '48',
        '49',
        '50',
        '51',
        '52',
        '53',
        '54',
        '55',
        '56',
        '57',
        '58',
        '59',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['60', '61', '62', '63', '64', '65', '66', '67', '68', '69'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['70', '71', '72', '73', '74', '75', '76', '77', '78', '79'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['80', '81', '82', '83', '84', '85', '86', '87', '88', '89'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['90', '91', '92', '93', '94', '95', '96', '97', '98'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'perception',
      questions: [
        '99',
        '100',
        '101',
        '102',
        '103',
        '104',
        '105',
        '106',
        '107',
        '108',
        '109',
        '110',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'ITHandling',
      questions: ['111', '112', '113'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'text',
      title: 'comments',
      name: '-20',
      optional: true,
    },
  ],
  'KAPP_SNIZ_M(R)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction1P',
      title: 'instruction.title',
      description: 'instruction.text',
    },
    { type: 'makaton' },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: [
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'memory',
      questions: ['22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'attention',
      questions: ['32', '33', '34', '35', '36', '37'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['38', '39', '40', '41', '42', '43', '44', '45', '46', '47'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: [
        '48',
        '49',
        '50',
        '51',
        '52',
        '53',
        '54',
        '55',
        '56',
        '57',
        '58',
        '59',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['60', '61', '62', '63', '64', '65', '66', '67', '68', '69'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['70', '71', '72', '73', '74', '75', '76', '77', '78', '79'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['80', '81', '82', '83', '84', '85', '86', '87', '88', '89'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['90', '91', '92', '93', '94', '95', '96', '97', '98'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'perception',
      questions: [
        '99',
        '100',
        '101',
        '102',
        '103',
        '104',
        '105',
        '106',
        '107',
        '108',
        '109',
        '110',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'ITHandling',
      questions: ['111', '112', '113'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
  ],
  'KAPP_SNIU(R)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction1P',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    { type: 'makaton' },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'memory',
      questions: [
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'attention',
      questions: ['32', '33', '34', '35', '36', '37'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['38', '39', '40', '41', '42', '43', '44', '45', '46', '47'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['48', '49', '50', '51', '52', '53', '54', '55', '56', '57'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['58', '59', '60', '61', '62', '63', '64', '65', '66', '67'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['68', '69', '70', '71', '72', '73', '74', '75', '76', '77'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['78', '79', '80', '81', '82', '83', '84', '85', '86', '87'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['88', '89', '90', '91', '92', '93', '94'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '95',
        '96',
        '97',
        '98',
        '99',
        '100',
        '101',
        '102',
        '103',
        '104',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '105',
        '106',
        '107',
        '108',
        '109',
        '110',
        '111',
        '112',
        '113',
        '114',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '115',
        '116',
        '117',
        '118',
        '119',
        '120',
        '121',
        '122',
        '123',
        '124',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '125',
        '126',
        '127',
        '128',
        '129',
        '130',
        '131',
        '132',
        '133',
        '134',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['135', '136', '137', '138', '139', '140', '141', '142'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'perception',
      questions: [
        '143',
        '144',
        '145',
        '146',
        '147',
        '148',
        '149',
        '150',
        '151',
        '152',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'perception',
      questions: ['153', '154', '155', '156', '157'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'readAndWrite',
      questions: [
        '158',
        '159',
        '160',
        '161',
        '162',
        '163',
        '164',
        '165',
        '166',
        '167',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'readAndWrite',
      questions: [
        '168',
        '169',
        '170',
        '171',
        '172',
        '173',
        '174',
        '175',
        '176',
        '177',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'readAndWrite',
      questions: ['178', '179', '180', '181', '182', '183', '184', '185'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'ITHandling',
      questions: [
        '186',
        '187',
        '188',
        '189',
        '190',
        '191',
        '192',
        '193',
        '194',
        '195',
        '196',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'text',
      title: 'comments',
      name: '-20',
      optional: true,
    },
  ],
  'KAPP_SNIU(N)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: [
        'teacher',
        'pedagogue',
        'psychologist',
        'therapist',
        'speechTherapist',
        'other',
      ],
    },
    { name: '-2', type: 'number', title: 'workTime' },
    {
      name: 'instruction',
      type: 'instruction1T',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    { type: 'makaton' },

    {
      type: 'matrix',
      title: 'coord',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'memory',
      questions: [
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'attention',
      questions: ['32', '33', '34', '35', '36', '37'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['38', '39', '40', '41', '42', '43', '44', '45', '46', '47'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['48', '49', '50', '51', '52', '53', '54', '55', '56', '57'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['58', '59', '60', '61', '62', '63', '64', '65', '66', '67'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['68', '69', '70', '71', '72', '73', '74', '75', '76', '77'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['78', '79', '80', '81', '82', '83', '84', '85', '86', '87'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['88', '89', '90', '91', '92', '93', '94'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '95',
        '96',
        '97',
        '98',
        '99',
        '100',
        '101',
        '102',
        '103',
        '104',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '105',
        '106',
        '107',
        '108',
        '109',
        '110',
        '111',
        '112',
        '113',
        '114',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '115',
        '116',
        '117',
        '118',
        '119',
        '120',
        '121',
        '122',
        '123',
        '124',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '125',
        '126',
        '127',
        '128',
        '129',
        '130',
        '131',
        '132',
        '133',
        '134',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['135', '136', '137', '138', '139', '140', '141', '142'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'perception',
      questions: [
        '143',
        '144',
        '145',
        '146',
        '147',
        '148',
        '149',
        '150',
        '151',
        '152',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'perception',
      questions: ['153', '154', '155', '156', '157'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'readAndWrite',
      questions: [
        '158',
        '159',
        '160',
        '161',
        '162',
        '163',
        '164',
        '165',
        '166',
        '167',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'readAndWrite',
      questions: [
        '168',
        '169',
        '170',
        '171',
        '172',
        '173',
        '174',
        '175',
        '176',
        '177',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'readAndWrite',
      questions: ['178', '179', '180', '181', '182', '183', '184', '185'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'ITHandling',
      questions: [
        '186',
        '187',
        '188',
        '189',
        '190',
        '191',
        '192',
        '193',
        '194',
        '195',
        '196',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'text',
      title: 'comments',
      name: '-20',
      optional: true,
    },
  ],
  'KAPP_SNIG(N)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: [
        'teacher',
        'pedagogue',
        'psychologist',
        'therapist',
        'speechTherapist',
        'other',
      ],
    },
    { name: '-2', type: 'number', title: 'workTime' },
    {
      name: 'instruction',
      type: 'instruction1T',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    { type: 'makaton' },

    {
      type: 'matrix',
      title: 'coord',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['31', '32', '33', '34', '35', '36', '37', '38', '39', '40'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['41', '42', '43', '44', '45', '46', '47'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'memory',
      questions: ['48', '49', '50', '51', '52', '53'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'attention',
      questions: ['54', '55', '56', '57', '58', '59', '60'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['61', '62', '63', '64'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'expression',
      questions: ['65', '66', '67', '68', '69', '70', '71', '72', '73', '74'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '75',
        '76',
        '77',
        '78',
        '79',
        '80',
        '81',
        '82',
        '83',
        '84',
        '85',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'perception',
      questions: ['86', '87', '88', '89', '90', '91', '92', '93', '94', '95'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'perception',
      questions: ['96', '97', '98', '99', '100'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'text',
      title: 'comments',
      name: '-20',
      optional: true,
    },
  ],
  'KAPP_SNIG(R)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction1P',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    { type: 'makaton' },

    {
      type: 'matrix',
      title: 'coord',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['31', '32', '33', '34', '35', '36', '37', '38', '39', '40'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['41', '42', '43', '44', '45', '46', '47'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'memory',
      questions: ['48', '49', '50', '51', '52', '53'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'attention',
      questions: ['54', '55', '56', '57', '58', '59', '60'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['61', '62', '63', '64'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'expression',
      questions: ['65', '66', '67', '68', '69', '70', '71', '72', '73', '74'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '75',
        '76',
        '77',
        '78',
        '79',
        '80',
        '81',
        '82',
        '83',
        '84',
        '85',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'perception',
      questions: ['86', '87', '88', '89', '90', '91', '92', '93', '94', '95'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'perception',
      questions: ['96', '97', '98', '99', '100'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'text',
      title: 'comments',
      name: '-20',
      optional: true,
    },
  ],
  'KAPP_SNIZ_S(N)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: [
        'teacher',
        'pedagogue',
        'psychologist',
        'therapist',
        'speechTherapist',
        'other',
      ],
    },
    { name: '-2', type: 'number', title: 'workTime' },
    {
      name: 'instruction',
      type: 'instruction1T',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    { type: 'makaton' },

    {
      type: 'matrix',
      title: 'coord',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['21', '22', '23', '24', '25', '26', '27'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'memory',
      questions: [
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'attention',
      questions: ['39', '40', '41', '42', '43', '44'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['45', '46', '47', '48', '49', '50', '51', '52', '53', '54'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['55', '56', '57', '58', '59', '60', '61', '62', '63', '64'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['65', '66', '67', '68', '69', '70', '71'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'expression',
      questions: ['72', '73', '74', '75', '76', '77', '78', '79', '80', '81'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['82', '83', '84', '85', '86', '87', '88', '89', '90', '91'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['92', '93', '94', '95', '96', '97', '98', '99', '100', '101'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '102',
        '103',
        '104',
        '105',
        '106',
        '107',
        '108',
        '109',
        '110',
        '111',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['112', '113', '114', '115', '116', '117'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'perception',
      questions: [
        '118',
        '119',
        '120',
        '121',
        '122',
        '123',
        '124',
        '125',
        '126',
        '127',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'perception',
      questions: [
        '128',
        '129',
        '130',
        '131',
        '132',
        '133',
        '134',
        '135',
        '136',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'readAndWrite',
      questions: ['137', '138', '139', '140', '141', '142'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'ITHandling',
      questions: ['143', '144', '145', '146'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'text',
      title: 'comments',
      name: '-20',
      optional: true,
    },
  ],
  'KAPP_SNIZ_S(R)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction1P',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    { type: 'makaton' },

    {
      type: 'matrix',
      title: 'coord',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'coord',
      questions: ['21', '22', '23', '24', '25', '26', '27'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'memory',
      questions: [
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'attention',
      questions: ['39', '40', '41', '42', '43', '44'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['45', '46', '47', '48', '49', '50', '51', '52', '53', '54'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['55', '56', '57', '58', '59', '60', '61', '62', '63', '64'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'comprehension',
      questions: ['65', '66', '67', '68', '69', '70', '71'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'expression',
      questions: ['72', '73', '74', '75', '76', '77', '78', '79', '80', '81'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['82', '83', '84', '85', '86', '87', '88', '89', '90', '91'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['92', '93', '94', '95', '96', '97', '98', '99', '100', '101'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: [
        '102',
        '103',
        '104',
        '105',
        '106',
        '107',
        '108',
        '109',
        '110',
        '111',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'expression',
      questions: ['112', '113', '114', '115', '116', '117'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'perception',
      questions: [
        '118',
        '119',
        '120',
        '121',
        '122',
        '123',
        '124',
        '125',
        '126',
        '127',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'matrix',
      title: 'perception',
      questions: [
        '128',
        '129',
        '130',
        '131',
        '132',
        '133',
        '134',
        '135',
        '136',
      ],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'readAndWrite',
      questions: ['137', '138', '139', '140', '141', '142'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },

    {
      type: 'matrix',
      title: 'ITHandling',
      questions: ['143', '144', '145', '146'],
      answers: ['yes', 'yesWithHelp', 'partially', 'notYet', 'notApplicable'],
    },
    {
      type: 'text',
      title: 'comments',
      name: '-20',
      optional: true,
    },
  ],

  'KAPP_S_S(N)': [
    {
      name: '-5',
      title: 'childSchoolYear',
      type: 'select',
      options: ['1', '2', '3', '4'], //doc has unspecified class, could be 1-6
    },

    { type: 'personFillingScaleWithOptions' },

    {
      name: 'instruction',
      type: 'instruction2T',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['31', '32', '33', '34', '35', '36', '37', '38', '39', '40'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['41', '42', '43', '44', '45', '46', '47', '48', '49', '50'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['51', '52', '53', '54', '55', '56', '57', '58'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },

    {
      type: 'matrix',
      title: 'communication',
      questions: ['59', '60', '61', '62', '63', '64', '65', '66', '67', '68'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['69', '70', '71', '72', '73', '74', '75', '76', '77', '78'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['79', '80', '81', '82', '83', '84', '85', '86', '87', '88'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['89', '90', '91', '92', '93'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
  ],
  'KAPP_S_S(R)': [
    {
      type: 'languageSelection',
    },
    {
      name: '-5',
      title: 'childSchoolYear',
      type: 'select',
      options: ['1', '2', '3', '4'],
    },
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction2P',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['31', '32', '33', '34', '35', '36', '37', '38', '39', '40'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['41', '42', '43', '44', '45', '46', '47', '48', '49', '50'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['51', '52', '53', '54', '55', '56', '57'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },

    {
      type: 'matrix',
      title: 'communication',
      questions: ['58', '59', '60', '61', '62', '63', '64', '65', '66', '67'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['68', '69', '70', '71', '72', '73', '74', '75', '76', '77'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['78', '79', '80', '81', '82', '83', '84'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
  ],
  'KAPP_S_P(N)': [
    { type: 'personFillingScaleWithOptionsAlt' },
    {
      name: 'instruction',
      type: 'instruction2T',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['31', '32', '33', '34', '35', '36', '37', '38', '39', '40'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['41', '42', '43', '44', '45', '46', '47', '48'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },

    {
      type: 'matrix',
      title: 'communication',
      questions: ['49', '50', '51', '52', '53', '54', '55', '56', '57', '58'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['59', '60', '61', '62', '63', '64', '65', '66', '67', '68'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['69', '70', '71', '72', '73', '74'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
  ],
  'KAPP_S_P(R)': [
    {
      type: 'languageSelection',
    },
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction2P',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    // pl
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['31', '32', '33', '34', '35', '36', '37', '38', '39', '40'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['41', '42', '43', '44', '45'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },

    {
      type: 'matrix',
      title: 'communication',
      questions: ['46', '47', '48', '49', '50', '51', '52', '53', '54', '55'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['56', '57', '58', '59', '60', '61', '62', '63', '64', '65'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['66', '67', '68', '69', '70', '71'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    // en
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'en',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'en',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'en',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['31', '32', '33', '34', '35', '36', '37', '38', '39', '40'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'en',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['41', '42', '43', '44', '45'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'en',
    },

    {
      type: 'matrix',
      title: 'communication',
      questions: [
        '46',
        '51',
        '53',
        '54',
        '55',
        '60',
        '64',
        '65',
        '67',
        '68',
        '69',
        '70',
      ],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'en',
    },
    // ua
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'ua',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'ua',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'ua',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['31', '32', '33', '34', '35', '36', '37', '38', '39', '40'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'ua',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['41', '42', '43', '44', '45'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'ua',
    },

    {
      type: 'matrix',
      title: 'communication',
      questions: [
        '46',
        '51',
        '53',
        '54',
        '55',
        '60',
        '64',
        '65',
        '67',
        '68',
        '69',
        '70',
      ],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'ua',
    },
    // vi
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'vi',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'vi',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'vi',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['31', '32', '33', '34', '35', '36', '37', '38', '39', '40'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'vi',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['41', '42', '43', '44', '45'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'vi',
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: [
        '46',
        '51',
        '53',
        '54',
        '55',
        '60',
        '64',
        '65',
        '67',
        '68',
        '69',
        '70',
      ],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
      language: 'vi',
    },
  ],

  'KAPP_S_D3-5(R)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction2P',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },

    {
      type: 'matrix',
      title: 'communication',
      questions: ['19', '20', '21', '22', '23', '24', '25', '26', '27', '28'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['29', '30', '31', '32'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      name: '33',
      title: 'KAPP_S_D3-5(R).questions.33',
      type: 'text',
    },
    {
      name: '34',
      title: 'KAPP_S_D3-5(R).questions.34',
      type: 'text',
    },
  ],
  'KAPP_S_D6-11(R)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction2P',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: [
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
      ],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['32', '33', '34', '35', '36', '37', '38', '39', '40'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      name: '41',
      title: 'KAPP_S_D6-11(R).questions.41',
      type: 'text',
    },
    {
      name: '42',
      title: 'KAPP_S_D6-11(R).questions.42',
      type: 'text',
    },
  ],
  'KAPP_S_D12-17(R)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction2P',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: [
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
      ],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },

    {
      type: 'matrix',
      title: 'communication',
      questions: ['24', '25', '26', '27', '28', '29', '30', '31', '32', '33'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: [
        '34',
        '35',
        '36',
        '37',
        '38',
        '39',
        '40',
        '41',
        '42',
        '43',
        '44',
      ],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      name: '45',
      title: 'KAPP_S_D12-17(R).questions.45',
      type: 'text',
    },
    {
      name: '46',
      title: 'KAPP_S_D12-17(R).questions.46',
      type: 'text',
    },
  ],
  'KAPP_S_D18-23(R)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction2P',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },

    {
      type: 'matrix',
      title: 'communication',
      questions: ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['31', '32', '33', '34'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      name: '35',
      title: 'KAPP_S_D18-23(R).questions.35',
      type: 'text',
    },
    {
      name: '36',
      title: 'KAPP_S_D18-23(R).questions.36',
      type: 'text',
    },
  ],
  'KAPP_S_D24-29(R)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction2P',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['31', '32', '33', '34', '35', '36', '37', '38', '39', '40'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'communication',
      questions: ['41', '42', '43', '44', '45'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      name: '46',
      title: 'KAPP_S_D24-29(R).questions.46',
      type: 'text',
    },
    {
      name: '47',
      title: 'KAPP_S_D24-29(R).questions.47',
      type: 'text',
    },
  ],
  'KAPP_S_D30-35(R)': [
    {
      name: '-1',
      title: 'personFillingScale',
      type: 'select',
      options: ['mother', 'father', 'guardian1', 'guardian2'],
    },
    {
      name: 'instruction',
      type: 'instruction2P',
      title: 'instruction.title',
      description: 'instruction.description',
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      type: 'matrix',
      title: 'cognitive',
      questions: ['21', '22', '23', '24'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },

    {
      type: 'matrix',
      title: 'communication',
      questions: ['25', '26', '27', '28', '29', '30', '31', '32', '33', '34'],
      answers: ['no', 'probablyNot', 'probablyYes', 'yes'],
    },
    {
      name: '35',
      title: 'KAPP_S_D30-35(R).questions.35',
      type: 'text',
    },
    {
      name: '36',
      title: 'KAPP_S_D30-35(R).questions.36',
      type: 'text',
    },
  ],
}
